export function fixSVGClassListSupportForIE() {
  /* istanbul ignore next */
  if (!('classList' in SVGElement.prototype)) {
    Object.defineProperty(SVGElement.prototype, 'classList', {
      get: function getClassList(this: SVGElement) {
        return {
          contains: (className: string) => this.className.baseVal.split(' ').indexOf(className) !== -1,
        };
      },
    });
  }
}
